import { render, staticRenderFns } from "./InputCheckbox.vue?vue&type=template&id=608c7555&"
import script from "./InputCheckbox.vue?vue&type=script&lang=js&"
export * from "./InputCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./InputCheckbox.vue?vue&type=style&index=0&id=608c7555&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports